import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/chevron-down.svg'


const _withScopeId = n => (_pushScopeId("data-v-5e1bfd4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wallet-contribution"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Your Contribution:", -1))
const _hoisted_3 = { class: "wallet-contribution__amount" }
const _hoisted_4 = {
  key: 1,
  class: "contributors-list"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CONTRIBUTORS", -1))
const _hoisted_6 = {
  key: 0,
  class: "contributors-list__content"
}
const _hoisted_7 = { class: "contributors-list__scroll" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "contributors-list__amount" }
const _hoisted_10 = {
  key: 0,
  class: "contributors-list__row contributors-list__remaining"
}

import { onMounted, ref, watch } from 'vue';
import { URLs } from '@manifoldxyz/js-ts-utils';
import { appsApi } from '@/api/apiHelpers';
import { resolveENSFromBadges } from '@/lib/address';
import { abbreviateAddress } from '@/lib/claimUtil';
import { useClaimStore } from '@/store/claimStore';

// Define the Contributor interface
interface Contributor {
  totalRevenue: string;
  fromAddress: string;
  ensOrAddress?: string;
  isResolvingENS?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PledgeLeaderboard',
  setup(__props) {

const store = useClaimStore();
const isOpen = ref(true);
const contributors = ref<Contributor[]>([]);
const remainingContributors = ref(0);
const walletContribution = ref<string>('0');
const isLoading = ref(true);

// Add helper function to check if address matches wallet
const isWalletAddress = (address: string) => {
  return address.toLowerCase() === store.walletAddress?.toLowerCase();
};

// Fetch data function to reuse in mounted and watch
const fetchContributorData = async (walletAddress?: string) => {
  const networkId = store.networkId;
  const contractAddress = store.creatorContractAddress;
  const instanceId = store.id;

  if (walletAddress) {
    const walletResponse = await appsApi.getMintFeeTotal(
      networkId,
      contractAddress,
      instanceId.toString(),
      walletAddress
    );
    if (walletResponse.contributors.length > 0) {
      walletContribution.value = walletResponse.contributors[0].totalRevenue;
    }
  }

  const response = await appsApi.getMintFeeTotal(networkId, contractAddress, instanceId.toString());

  contributors.value = response.contributors.map((contributor: any) => ({
    totalRevenue: contributor.totalRevenue,
    fromAddress: contributor.fromAddress,
    ensOrAddress: abbreviateAddress(contributor.fromAddress),
    isResolvingENS: true,
  }));

  remainingContributors.value = response.total - contributors.value.length;

  // Resolve ENS names asynchronously
  contributors.value.forEach(async (contributor, index) => {
    try {
      const ensName = await resolveENSFromBadges(contributor.fromAddress);
      if (ensName) {
        contributors.value[index].ensOrAddress = ensName;
      }
    } finally {
      contributors.value[index].isResolvingENS = false;
    }
  });
};

onMounted(async () => {
  try {
    await fetchContributorData(store.walletAddress);
  } catch (error) {
    console.error('Error fetching contributors:', error);
  } finally {
    isLoading.value = false;
  }
});

// Update watcher to use fetchContributorData
watch(
  () => store.walletAddress,
  async (newWalletAddress) => {
    if (newWalletAddress) {
      isLoading.value = true;
      try {
        await fetchContributorData(newWalletAddress);
      } finally {
        isLoading.value = false;
      }
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (Number(walletContribution.value) > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(Math.floor(Number(walletContribution.value) / 0.0005).toLocaleString()), 1)
        ]))
      : _createCommentVNode("", true),
    (!isLoading.value && contributors.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "contributors-list__header",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value))
          }, [
            _hoisted_5,
            _createElementVNode("img", {
              src: _imports_0,
              class: _normalizeClass({ 'is-open': isOpen.value })
            }, null, 2)
          ]),
          (isOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contributors.value, (contributor) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["contributors-list__row", { 'is-wallet': isWalletAddress(contributor.fromAddress) }]),
                      key: contributor.fromAddress
                    }, [
                      _createElementVNode("a", {
                        href: _unref(URLs).getEtherscanURLForAddress(_unref(store).networkId, contributor.fromAddress),
                        target: "_blank",
                        class: "contributors-list__address"
                      }, _toDisplayString(contributor.ensOrAddress || _unref(abbreviateAddress)(contributor.fromAddress)), 9, _hoisted_8),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(Math.floor(Number(contributor.totalRevenue) / 0.0005).toLocaleString()), 1)
                    ], 2))
                  }), 128)),
                  (remainingContributors.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("span", null, "And " + _toDisplayString(remainingContributors.value) + " more contributors...", 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})